import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateCheckFormatter',
})

export class DateCheckFormatterPipe implements PipeTransform {
  transform(value: Date | string, format?: string) {

    if (!value) {
      return ''; 
    }

    const locale = localStorage.getItem('selectedlanguage') || 'de-DE';
    const date = new Date(value);

    let formattedDate: string;
    let formattedTime: string;

    switch (format) {
      case 'fullDate':
        formattedDate = new Intl.DateTimeFormat(locale, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }).format(date);
        formattedTime = '';
        break;
      case 'time12Hour':
        formattedTime = new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit', hour12: true }).format(date);
        formattedDate = '';
        break;
      default:
        const timeFormatter = new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit', hour12: true });
        const dateFormatter = new Intl.DateTimeFormat(locale, { month: 'numeric', day: 'numeric', year: 'numeric' });
        formattedDate = dateFormatter.format(date).replace(/(\d)([.] )/g, '$1, ').replace(/, (\w)/, ' $1');
        formattedTime = ', '+timeFormatter.format(date).toLowerCase();
        break;
    }

    return formattedTime ? `${formattedDate}${formattedTime}` : formattedDate;
  }


    transformToDownloadModal(value: Date, format?: string) {
      const locale = localStorage.getItem('selectedlanguage') || 'de-DE';
      const timeFormatter = new Intl.DateTimeFormat(locale, {hour: '2-digit', minute: '2-digit', hour12: false });
      const dateFormatter = new Intl.DateTimeFormat(locale, {month: 'long', day: 'numeric', year: 'numeric'});
      const date = new Date(value);
      const formattedTime = timeFormatter.format(date).toLowerCase();

      const formattedDate = dateFormatter.format(date).replace(/(\d)([.] )/g, '$1, ').replace(/, (\w)/, ' $1');
      const formattedDateArray = formattedDate.split(' ');
      const formattedDateToReturn = `${formattedDateArray[1]} ${formattedDateArray[0]}, ${formattedDateArray[2]}`;

      const responseArray = [formattedTime, formattedDateToReturn];
      return responseArray;
    }
}

